import axios from '@axios'

const PREFIX = 'EnvioHistorico'

export default {
  registrarManual(dados) {
    return axios.post(`${PREFIX}/registrar-manual`, dados)
  },
  obterStatus(tipoRotina, ids) {
    return axios.get(`${PREFIX}/status/${tipoRotina}?ids=${ids.join(',')}`)
  },
}
